import UnderProgress from "../../tools/UnderProgress"

const LeadsVisibility = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <UnderProgress />
    </div>
  )
}

export default LeadsVisibility
